import { Component, OnInit } from '@angular/core';
import { UtilityService } from '../../services/utility.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { SessionService } from '../../services/session.service';
import { environment } from '../../../environments/environment';
import { FlashMessagesService } from 'angular2-flash-messages';
import Swal from 'sweetalert2';
import { Md5 } from 'ts-md5/dist/md5';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
	selector: 'app-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit {
	loginForm: FormGroup;
	otpForm: FormGroup;
	submitted = false;
	iserror: any = false;
	errormsg: any;
	apiUrl: any;
	md5: any;
	appKey: any;
	appId: any;
	showLoginForm: boolean = true;
	showOtpForm: boolean = false;
	requestObj: any;
	status: any;
	application_id: any;
	emailAddress: any;
	password: any;
	loginObj: any;
	DA_appId: number;
	applications: any[] = [];

	fieldTextType: boolean;
	fieldTextType2: boolean;

	// tslint:disable-next-line: max-line-length
	constructor(
		private formBuilder: FormBuilder,
		private http: HttpClient,
		private router: Router,
		private sess: SessionService,
		private UtilityService: UtilityService,
		private spinnerService: Ng4LoadingSpinnerService
	) {}

	ngOnInit(): void {
		this.sess.islogin();
		// this.sess.checkLogin();
		// localStorage.removeItem('otp_username');
		this.loginForm = this.formBuilder.group({
			application_id: ['', Validators.required],
			emailAddress: [
				'',
				[
					Validators.required,
					Validators.maxLength(45),
					Validators.pattern(
						/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
					),
				],
			],
			password: ['', [Validators.required]],
		});

		this.initialiseOtpForm();

		this.getApplications();

		// $(".mobile-menu").css("display", "none");
	}

	initialiseOtpForm() {
		this.otpForm = this.formBuilder.group({
			enterOtp: ['', [Validators.required, Validators.pattern(/^[0-9]*$/)]],
		});
	}

	onSubmit(formAllData: any) {
		this.submitted = true;

		if (this.loginForm.invalid) {
			return;
		}

		this.application_id = formAllData.application_id;
		this.emailAddress = formAllData.emailAddress;
		this.password = formAllData.password;
		this.appId = environment.APPLICATION_ID;

		this.loginObj = {
			application_id: formAllData.application_id,
			email: this.emailAddress,
			password: this.password,
			// application_id: this.appId,
		};

		this.requestObj = {
			application_id: formAllData.application_id,
			email: formAllData.emailAddress,
			password: formAllData.password,
		};

		// request for OTP
		if (this.loginForm.valid) {
			this.submitted = false;

			this.spinnerService.show();

			this.apiUrl = environment.AUTHAPIURL + 'auth/credentials-verify';
			this.http.post<any>(this.apiUrl, this.loginObj).subscribe((data) => {
				console.log(data);

				if (data.status == true) {
					this.initialiseOtpForm();
					this.showLoginForm = true;
					this.showOtpForm = false;
					this.requestNewOtp();
				} else {
					this.spinnerService.hide();
					this.showLoginForm = true;
					this.showOtpForm = false;

					Swal.fire({
						icon: 'error',
						title: 'Oops...',
						text:
							data.response != null ? data.response[0].message : data.message,
						showConfirmButton: true,
						timer: 5000,
						timerProgressBar: true,
					});
				}
			});
		} else {
			return;
		}
	}

	onOtpSubmit(otpFormData) {
		this.submitted = true;
		this.requestObj.otp = otpFormData.enterOtp;
		console.log('otpFormData: ', otpFormData);
		console.log('loginRequest: ', this.requestObj);

		if (this.otpForm.valid) {
			this.userLogin(this.requestObj);
		} else {
			return;
		}
	}

	requestNewOtp() {
		this.spinnerService.show();
		this.initialiseOtpForm();

		var otpObjData = {
			email: this.emailAddress,
		};

		this.apiUrl = environment.AUTHAPIURL + 'otp/registered-send';

		this.http.post<any>(this.apiUrl, otpObjData).subscribe((data) => {
			console.log('otpApiResponse: ', data);
			this.spinnerService.hide();

			if (data.status == true) {
				this.showLoginForm = false;
				this.showOtpForm = true;

				Swal.fire({
					icon: 'success',
					title: 'Success',
					text: 'The OTP has been sent to mail successfully!',
					showConfirmButton: true,
					timer: 5000,
					timerProgressBar: true,
				});
			} else {
				this.showLoginForm = true;
				this.showOtpForm = false;

				Swal.fire({
					icon: 'error',
					title: 'Oops...',
					text: data.message,
					showConfirmButton: true,
					timer: 5000,
					timerProgressBar: true,
				});
			}
		});
	}

	backToLogin() {
		this.showLoginForm = true;
		this.showOtpForm = false;
	}

	userLogin(jsonData: any) {
		this.spinnerService.show();
		this.apiUrl = environment.AUTHAPIURL + 'auth/login';
		this.appKey = environment.APPLICATION_ID;
		this.md5 = Md5.hashStr(
			this.appKey + JSON.stringify(jsonData) + this.appKey
		);

		const myheaders = new HttpHeaders({
			'Content-Type': 'application/json',
			token: this.md5,
		});

		const options = { headers: myheaders };

		this.http.post<any>(this.apiUrl, jsonData, options).subscribe((data) => {
			console.log('loginApiResponse: ', data);
			this.status = data.status;
			let defaultPwd = -1;
			
			if (data.response != null) {
				defaultPwd = data.response.changed_default_password;
			}

			if (defaultPwd == 0) {
				this.spinnerService.hide();
				localStorage.setItem('username', data.response.email);
				Swal.fire({
					icon: 'info',
					title: 'Info',
					text: data.message,
					showConfirmButton: true,
					timer: 5000,
					timerProgressBar: true,
				});
				this.router.navigate(['/resetpassword']);
			} else {
				// this.spinnerService.hide();
				if (this.status == true) {
					// console.log("userData: ", data.response);
					localStorage.setItem('email', data.response.user.email);
					localStorage.setItem('id', data.response.user.id);

					localStorage.setItem('access_token', data.response.access_token);

					localStorage.setItem('role_id', data.response.user.role_id);
					localStorage.setItem(
						'application_id',
						data.response.user.application_id
					);
					localStorage.setItem('phone', data.response.user.phone);
					localStorage.setItem('active', data.response.user.active);
					localStorage.setItem('name', data.response.user.name);
					localStorage.setItem(
						'application_name',
						data.response.user.application.name
					);
					localStorage.setItem(
						'changed_default_password',
						data.response.user.changed_default_password
					);
					localStorage.setItem(
						'profile_image',
						data.response.user.profile_image
					);
					localStorage.setItem('created_at', data.response.user.created_at);
					localStorage.setItem('updated_at', data.response.user.updated_at);

					this.spinnerService.hide();

					if (data.response.user.application_id == 1) {
						this.router.navigate(['/lab-dashboard']);
					} else if (data.response.user.application_id == 2) {
						this.router.navigate(['/sample-center-dashboard']);
					} else if (data.response.user.application_id == 3) {
						this.router.navigate(['/ministry-dashboard']);
					}else if (data.response.user.application_id == 4) {
						this.router.navigate(['/airport-dashboard']);
					}else {
						this.router.navigate(['/dashboard']);
					}
				} else {
					this.spinnerService.hide();

					Swal.fire({
						icon: 'error',
						title: 'Oops...',
						text: data.message,
						showConfirmButton: true,
						timer: 5000,
						timerProgressBar: true,
					});
				}
			}
		});
	}

	resolved(captchaResponse: string) {
		console.log(`Resolved captcha with response: ${captchaResponse}`);
	}

	getApplications() {
		this.spinnerService.show();
		this.apiUrl = environment.AUTHAPIURL + 'applications';
		this.http.get<any>(this.apiUrl).subscribe((data) => {
			this.spinnerService.hide();
			if (data.status == true) {
				this.applications = data.response;
			} else {
				Swal.fire({
					icon: 'info',
					title: 'Oops...',
					text: data.message,
					showConfirmButton: true,
					timer: 5000,
					timerProgressBar: true,
				});
			}
		});
	}

	toggleFieldTextType() {
		this.fieldTextType = !this.fieldTextType;
	}
	toggleFieldTextType2() {
		this.fieldTextType2 = !this.fieldTextType2;
	}
}
